export const socialsData = {
    facebook: 'https://www.facebook.com/dr.feten.Taktak',
    instagram: 'https://www.instagram.com/faten_taktak',
    youtube: 'https://www.youtube.com/@drfetentaktak9587',
    tiktok:'https://www.tiktok.com/discover/dr-faten-taktak'
}